export default __webpack_public_path__ + "static/media/i360-logo-fondo-ideas.1f58ce9b.png";